import { initializeApp } from 'firebase/app'
import { getAuth, connectAuthEmulator, browserLocalPersistence, setPersistence } from 'firebase/auth'
import { initializeFirestore, connectFirestoreEmulator } from 'firebase/firestore'
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions'
import { getStorage, connectStorageEmulator } from 'firebase/storage'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

const app = initializeApp(firebaseConfig)

export const auth = getAuth(app)
// Expliciet local persistence afdwingen — zorgt dat de auth-sessie via
// IndexedDB bewaard blijft over tabs heen (belangrijk voor deep-links uit
// PDFs en mails). Zonder deze expliciete call valt Firebase soms terug op
// in-memory persistence in bepaalde browser-storage-modes.
setPersistence(auth, browserLocalPersistence).catch(err => {
  console.warn('Kon Firebase auth persistence niet zetten:', err)
})
// experimentalAutoDetectLongPolling: Safari (vaak ook op schoolnetwerken met
// proxies/content-filters) heeft de WebChannel-standaardverbinding van
// Firestore soms erg traag of hangend — dit laat de SDK zelf detecteren of
// long-polling nodig is, i.p.v. altijd de (voor Safari) tragere standaard te gebruiken.
export const db = initializeFirestore(app, { experimentalAutoDetectLongPolling: true })
export const functions = getFunctions(app, 'europe-west1')
export const storage = getStorage(app)

// Verbind met lokale emulators bij ontwikkeling
if (import.meta.env.DEV && import.meta.env.VITE_USE_EMULATORS === 'true') {
  connectAuthEmulator(auth, 'http://localhost:9098', { disableWarnings: true })
  connectFirestoreEmulator(db, 'localhost', 8080)
  connectFunctionsEmulator(functions, 'localhost', 5001)
  connectStorageEmulator(storage, 'localhost', 9199)
}
